module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "footer",
    class: [
      "footer", "pr",
      ("footer--" + (_vm.$route.name)),
      {
        'footer--sidebar': _vm.$route.meta.sidebar,
      }
    ],
    style: ({
      'background-color': _vm.org.custom_color3 == null ? '' : _vm.org.custom_color3,
    })
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "footer__logolinks"
  }, [_c('router-link', {
    class: [
      'footer__logoimg' ],
    attrs: {
      "to": {
        name: "home"
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/brand/footer-logo.svg"),
      "alt": "footer_logo"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "list list--footer mt-footer"
  }, _vm._l((_vm.footer.links), function(link) {
    return _c('li', {
      key: link.url,
      staticClass: "list__item1"
    }, [_c('router-link', {
      staticClass: "list c-white tdn link",
      attrs: {
        "to": {
          'name': link.url
        }
      }
    }, [_vm._v(_vm._s(link.label))])], 1)
  }), 0)], 1), _vm._v(" "), _c('p', {
    staticClass: "p small c-white pat2 mt0 p--no-width"
  }, [_vm._v(_vm._s(_vm.footer.copy))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef83699c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Footer.vue
// module id = 271
// module chunks = 2